import React from 'react';
import Link from 'next/link';
import type { ArticleType } from 'types';
import ResponsiveImage from 'components/base/responsiveImage/ResponsiveImage';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import { ArticleAttribution } from './ArticleAttribution';
import { ArticleTags } from './ArticleTags';

export function Article({
  title,
  excerpt,
  href,
  featuredImage,
  attribution,
  tags,
}: ArticleType): React.JSX.Element {
  const hasFeaturedImage = Boolean(featuredImage?.image);

  return (
    <div className="article">
      <Link href={href} className="article__link">
        {hasFeaturedImage && featuredImage && (
          <div className="article__image">
            <div className="article__tags">
              <ArticleTags tags={tags} asLinks={false} />
            </div>
            <ResponsiveImage
              images={featuredImage}
              alt={featuredImage.image?.alt || ''}
            />
          </div>
        )}
        <div className="article__header">
          <h2 className="article__title">
            <Wysiwyg isClean content={title} />
          </h2>
          <div className="article__attribution">
            <ArticleAttribution
              attribution={attribution}
              className="articleAttribution articleAttribution--card"
            />
          </div>
        </div>
        {excerpt && (
          <div className="article__excerpt">
            <Wysiwyg isClean content={excerpt} />
          </div>
        )}
      </Link>
    </div>
  );
}
